import * as Types from '@aeppic/types'
import type { SingleQueryStats } from 'model/indexing/query-stats.js'
import type { DocumentIdIterator } from '../../indexing/index-interface'
import type {
  DocumentMatchIterator,
  DocumentMatchIteratorJoined,
  DocumentMatchIteratorUsingId,
  DocumentMatchIteratorUsingIndex,
  KMergedIntersectionIterator,
  KMergedUnionIterator
} from '../iterator-types.js'

export interface EnumerationStrategy {
  getDocumentIdGenerator(
    iterator: DocumentMatchIterator,
    allDocuments?: Map<string, Types.Document>
  ): Generator<Types.DocumentId, void, unknown>

  enumerateKMergedUnion(
    iterator: KMergedUnionIterator,
    allDocuments?: Map<string, Types.Document>,
    stats?: SingleQueryStats
  ): Generator<Types.DocumentId, void, unknown>

  enumerateKMergedIntersection(
    iterator: KMergedIntersectionIterator,
    allDocuments?: Map<string, Types.Document>,
    stats?: SingleQueryStats
  ): Generator<Types.DocumentId, void, unknown>

  enumerateAllDocumentsInIndexIterator(
    iterator: DocumentMatchIteratorUsingIndex
  ): IterableIterator<Types.DocumentId>

  iteratorContains(
    iterator: DocumentMatchIteratorUsingIndex,
    documentId: Types.DocumentId
  ): boolean

  enumerateGraphIterator(
    iterator: DocumentMatchIterator,
    allDocuments: Map<string, Types.Document>,
    stats?: SingleQueryStats
  ): IterableIterator<Types.Document>

  enumerateIntersectionOfIterators(
    iterators: DocumentMatchIterator[],
    allDocuments: Map<string, Types.Document>,
    stats?: SingleQueryStats
  ): IterableIterator<Types.Document>

  enumerateUnionOfIterators(
    iterators: (DocumentMatchIteratorJoined | DocumentMatchIteratorUsingIndex | DocumentMatchIteratorUsingId)[],
    allDocuments: Map<string, Types.Document>,
    stats?: SingleQueryStats
  ): IterableIterator<Types.Document>

  _enumerateBTreeIntersection(
    iterators: DocumentMatchIteratorUsingIndex[],
    allDocuments: Map<string, Types.Document>,
    stats?: SingleQueryStats
  ): IterableIterator<Types.Document>
}

export type EnumerationStrategyFactory = () => EnumerationStrategy

export type EnumerationStrategyName = 'legacy' | 'experimental'
